<template>
  <base-table :data="getLogs">
    <el-table-column
    prop="party_id"
    :label="$t('sections.logsmLandingPage.table.component')"
    width="150%">
      <template slot-scope="scope">
        <span v-if="scope.row.party_id">OCPI</span>
        <span v-else>OCPP</span>
      </template>
    </el-table-column>
    <el-table-column
    prop="messageType"
    :label="$t('sections.logsmLandingPage.table.module')"
    width="150%">
      <template slot-scope="scope">
        <span v-if="scope.row.messageType">{{ scope.row.messageType }}</span>
        <span v-else>{{ scope.row.module }}</span>
      </template>
    </el-table-column>
    <el-table-column
    :label="$t('sections.logsmLandingPage.table.dateTime')"
    width="150%">
      <template slot-scope="props">
        {{
          props.row.timestamp
          ? formatTime(props.row.timestamp)
          : props.row.timestamp
        }}
      </template>
    </el-table-column>
    <el-table-column prop="logs" :label="$t('sections.logsmLandingPage.table.message')" />
  </base-table>
</template>
<script>
import { formatTime } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'LogsManagerTable',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getLogs']),
  },
  methods: {
    formatTime,
  },
};
</script>
<style lang="scss" scoped></style>
